export { default as EditPaymentMethodPage } from './EditPaymentMethodPage';
